import * as THREE from 'three';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

// Shared PMREM environment (MODELING.md: metals are BLACK without a bright env map). The main scene,
// the asset thumbnail renderer and the /admin LOD tool all pull from here so metal reads the same
// everywhere. PMREM textures are renderer-specific, so cache one per renderer.

const cache = new WeakMap<THREE.WebGLRenderer, THREE.Texture>();

export function sharedEnvironment(renderer: THREE.WebGLRenderer): THREE.Texture {
  let tex = cache.get(renderer);
  if (!tex) {
    const pmrem = new THREE.PMREMGenerator(renderer);
    tex = pmrem.fromScene(new RoomEnvironment(), 0.04).texture;
    pmrem.dispose();
    cache.set(renderer, tex);
  }
  return tex;
}
